export const RE68 = /^(?![1-9]\d{0,9}$).*/